import React, {  Component } from 'react';

export default class ActionDescriptionsOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('ActionDescriptionsOverlayDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="actionDescriptionsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton fontSize-10" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Action Descriptions</h2>
                    <div className="scroll-height-action-description">
    					<table className="dataTable actionDescriptionsTable">
    						<thead>
    							<tr>
    								<th>Action Name</th>
    								<th>Action Description</th>
    							</tr>
    						</thead>
    						<tbody>
    							<tr>
    								<td>No Available Actions</td>
    								<td>Order is shipping. You may call customer service for additional information.</td>
    							</tr>
    							<tr>
    								<td>View Status</td>
    								<td>
                                        <p>Displays the Expected Ship Date, the reserved quantity per line, and the ETA for any unreserved lines. When all lines are reserved, order status will continue to update as your order processes. Possible statuses include:</p>
                                        <p>Fully Reserved (SDS) - All items are reserved. Logistics can plan the shipment from the ADC</p>
                                        <p>Fully Reserved (ADC) - All items are reserved. Logistics can plan the order</p>
                                        <p>Shipment Planned (SDS) - Logistics has planned the shipment from the ADC to the SDS</p>
                                        <p>Shipment Planned (ADC) - Logistics has planned the shipment</p>
                                        <p>Shipped (ADC) - The order has left the ADC and all lines will close</p>
                                        <p>Arrived at SDS - The order is at the SDS facility</p>
                                        <p>Delivered (SDS) - The order is complete and checked in</p>
                                        <p>Ready for Pickup - For ADC Will Call orders only</p>
                                    </td>
    							</tr>
    							<tr>
    								<td>Edit Order</td>
    								<td>
                                        On a BOOKED order, depending on order status, this may allow you to CANCEL products or the entire order, SPLIT products off the order, ADD products or available backorders to the order, or H-back products off the order. On an ENTERED order, this will allow you to edit and BOOK the order.
                                    </td>
    							</tr>
    							<tr>
    								<td>Cancel Order</td>
    								<td>Cancels an ENTERED or BOOKED order.</td>
    							</tr>
    							<tr>
    								<td>Manage Backorders</td>
    								<td>Allows you to order backordered items that have become available.</td>
    							</tr>
    							<tr>
    								<td>Proof of Delivery</td>
    								<td>Provides delivery details when available.</td>
    							</tr>
    							<tr>
    								<td>View Serials</td>
    								<td>Provides serial numbers available.</td>
    							</tr>
    						</tbody>
    					</table>
                    </div>
            	</div>
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/actionDescriptionsOverlayDialog.js